import { handleResponse, authHeader } from '../helpers'

export const ctaService = {
    getAll,
    getAllAd,
    getCta,
    getCtaModels,
    getAdModels,
    getDefaultCta,
    getSlots,
    getAdSlots,
    add,
    update,
    saveSlot,
    preview,
}

function getAll () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/ctas`, requestOptions).then(handleResponse)
}

function getAllAd () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/ctas/ad`, requestOptions).then(handleResponse)
}

function getCta (id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/ctas/get/${id}`, requestOptions).then(handleResponse)
}

function getCtaModels () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/ctas/models/cta`, requestOptions).then(handleResponse)
}

function getAdModels () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/ctas/models/ad`, requestOptions).then(handleResponse)
}

function getDefaultCta (ctaType) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/ctas/default/${ctaType}`, requestOptions).then(handleResponse)
}

function getSlots () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/ctas/slots/cta`, requestOptions).then(handleResponse)
}

function getAdSlots () {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    }
    return fetch(`/ctas/slots/ad`, requestOptions).then(handleResponse)
}

function add (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/ctas`, requestOptions).then(handleResponse)
}

function update (params) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/ctas/${params.id}`, requestOptions).then(handleResponse)
}

function saveSlot (params) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/ctas/slot/${params.id}`, requestOptions).then(handleResponse)
}

function preview (params) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(params)
    }

    return fetch(`/ctas/preview`, requestOptions).then(handleResponse)
}


